export enum AttributeType {
    specialCondition = 'CONDICIONES_DEVOLUCION',
    noCompatibleWithGiftBox = 'NO_COMPATIBLE_CAJA_REGALO',
    safetyWarning = 'SAFETY_WARNING',
}
